import { useState } from "react";
import { formatExpiryDate } from "../../utils/formatters";
import styles from "./InventoryPage.module.css";

export default function InventoryPage({ products }) {
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  const filtered = products.filter(p =>
    (!typeFilter || p.type === typeFilter) &&
    (!search || p.description.toLowerCase().includes(search.toLowerCase()) ||
     p.manufacturer.toLowerCase().includes(search.toLowerCase()) ||
     (p.barcode || p.id).toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search inventory..."
          className={styles.searchInput} />
        <div className={styles.filterGroup}>
          {["", "Drug", "Supply"].map(t => (
            <button key={t} onClick={() => setTypeFilter(t)}
              className={typeFilter === t ? styles.filterBtnActive : styles.filterBtn}>
              {t || "All"}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.countLabel}>SHOWING {filtered.length} OF {products.length} PRODUCTS</div>
      <div className={styles.grid}>
        {filtered.map(p => (
          <div key={p.id} className={styles.productRow}>
            <div className={styles.productInfo}>
              <div className={styles.productTags}>
                <span className={p.type === "Drug" ? styles.tagDrug : styles.tagSupply}>{p.type}</span>
              </div>
              <div className={styles.productDesc}>{p.description}</div>
              <div className={styles.productMfg}>{p.manufacturer}</div>
              {p.lotNumber && <div className={styles.productLot}>Lot: {p.lotNumber}</div>}
              {p.expiryDate && <div className={styles.productLot}>Exp: {formatExpiryDate(p.expiryDate)}</div>}
            </div>
            <div className={styles.stockCol}>
              <div className={`${styles.stockValue} ${p.stock > 10 ? styles.stockGood : p.stock > 0 ? styles.stockWarn : styles.stockDanger}`}>
                {p.stock}
              </div>
              <div className={styles.stockLabel}>in stock</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
